import { BackendModel } from "../../core/backend.service";

export class ImagenBanner{
    id: number;
    nombre: string;
    path: string;
    url: string;
    file: File;
}



// WEBPACK FOOTER //
// ./src/app/banner/banner-imagen-upload/imagen-banner.model.ts